module.exports = __webpack_public_path__ + "img/the-will-of-the-many.8eb1882d.png";